import { render, staticRenderFns } from "./ToolBarRightMenuActionsItem.vue?vue&type=template&id=da70aa44&scoped=true&"
import script from "./ToolBarRightMenuActionsItem.vue?vue&type=script&lang=js&"
export * from "./ToolBarRightMenuActionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da70aa44",
  null
  
)

export default component.exports